import React, { useContext, useEffect } from 'react'

import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { useFileUpload } from 'app/api/useFileUpload'
import { API_BASE_URL, endpoints } from 'app/api/endpoints'
import { DocumentUploadInput, DocumentUploadResponse } from 'EstraSuppliers'
import { themeEstra } from 'app/styles/themeEstra'
import styled from 'styled-components'
import { InputFile } from 'app/components/ui/form/InputFile'
import { Text } from 'app/components/ui/Text'
import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { Button } from 'app/components/ui/Button'
import { validateInputPdfFile } from 'app/utils/file'

const apiUploadURL = `${API_BASE_URL}/${endpoints.uploadFile}`

interface Props {
  onFileUploadedSuccess: () => void
}

export const InputRegistryDocument: React.FC<Props> = ({
  onFileUploadedSuccess,
}) => {
  const authCtx = useContext(AuthenticationContext)
  const [fileToUpload, setFileToUpload] = React.useState<File | null>()
  const {
    uploadFile,
    uploadIsLoading,
    uploadSuccess,
    uploadError,
  } = useFileUpload<DocumentUploadInput, DocumentUploadResponse>(apiUploadURL)

  // on upload success refetch actor
  useEffect(() => {
    if (uploadSuccess && uploadSuccess.pdf_registry_url && authCtx) {
      authCtx.refetchActor()
      onFileUploadedSuccess()
    }
  }, [uploadSuccess?.pdf_registry_url])

  const inputFileName = 'inputRegistryDocumentInput'

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        if (fileToUpload && fileToUpload.name && authCtx) {
          uploadFile(
            {
              file: fileToUpload,
              type: 'pdf_registry',
            },
            {
              limitInMb: 10,
            }
          )
        }
      }}
    >
      <InputGroup>
        <InputFile
          name={inputFileName}
          accept='image/png, image/jpeg, image/jpg, application/pdf'
          selectedFileName={fileToUpload?.name}
          onChange={e => {
            const { file, isValid } = validateInputPdfFile(e)
            if (file && isValid) {
              setFileToUpload(file)
            }
          }}
        />
        <Text
          variant='s12'
          color={themeEstra.color.primari.grigioEstra}
          mt={0.5}
          isItalic
        >
          Formato immagine o PDF, dimensione massima 10 MB
        </Text>
        {uploadError ? (
          <FormFeedback variant='error'>{uploadError}</FormFeedback>
        ) : null}
      </InputGroup>

      {fileToUpload ? (
        <Button
          size='lg'
          disabled={
            uploadIsLoading ||
            Boolean(uploadSuccess && uploadSuccess.pdf_registry_url)
          }
        >
          {uploadIsLoading ? 'CARICAMENTO...' : 'SALVA'}
        </Button>
      ) : null}
    </form>
  )
}

const InputGroup = styled.div`
  margin-bottom: 2rem;

  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`
